import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { withGoogleMap } from 'react-google-maps/lib/withGoogleMap';
import { withScriptjs } from 'react-google-maps/lib/withScriptjs';
import { GoogleMap } from 'react-google-maps/lib/components/GoogleMap';
import { compose, withProps, withHandlers } from 'recompose';
import StoreMarker from './StoreMarker';

var _require = require('react-google-maps/lib/components/addons/MarkerClusterer'),
    MarkerClusterer = _require.MarkerClusterer;

var MyMapComponent = compose(withProps({
  googleMapURL: // 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCH56M32RW8yn1UhHgbHyfojxHSTjRJGpI&v=3.exp&libraries=geometry,drawing,places',
  'https://maps.googleapis.com/maps/api/js?key=AIzaSyAHD5Fsg27H9XvB3QWWn_mymfFBUg5VmCI&v=3.exp&libraries=geometry,drawing,places',
  loadingElement: React.createElement("div", {
    style: {
      height: "100%"
    }
  }),
  containerElement: React.createElement("div", {
    className: "containerElementWrapperClass",
    style: {
      height: "100%"
    }
  }),
  mapElement: React.createElement("div", {
    style: {
      minHeight: '45rem',
      height: "100%"
    }
  })
}), withHandlers({
  onMarkerClustererClick: function onMarkerClustererClick() {
    return function (markerClusterer) {
      markerClusterer.getMarkers();
    };
  }
}), withScriptjs, withGoogleMap)(function (props) {
  var _props$newPosition, _props$newPosition$ra, _props$newPosition2, _props$newPosition2$r, _props$stores;

  return React.createElement(GoogleMap, {
    defaultOptions: {
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false
    },
    defaultZoom: ((_props$newPosition = props.newPosition) === null || _props$newPosition === void 0 ? void 0 : (_props$newPosition$ra = _props$newPosition.radius) === null || _props$newPosition$ra === void 0 ? void 0 : _props$newPosition$ra.zoom) || 8,
    zoom: ((_props$newPosition2 = props.newPosition) === null || _props$newPosition2 === void 0 ? void 0 : (_props$newPosition2$r = _props$newPosition2.radius) === null || _props$newPosition2$r === void 0 ? void 0 : _props$newPosition2$r.zoom) || 8,
    defaultCenter: {
      lat: props.newPosition.lat,
      lng: props.newPosition.lng
    },
    center: {
      lat: props.newPosition.lat,
      lng: props.newPosition.lng
    }
  }, props.isMarkerShown && React.createElement(React.Fragment, null, React.createElement(MarkerClusterer, {
    onClick: props.onMarkerClustererClick,
    averageCenter: true,
    enableRetinaIcons: true,
    gridSize: 60
  }, props === null || props === void 0 ? void 0 : (_props$stores = props.stores) === null || _props$stores === void 0 ? void 0 : _props$stores.map(function (store) {
    return React.createElement(StoreMarker, _extends({
      key: "store-marker-".concat(store.store_id)
    }, props, {
      store: store
    }));
  }))));
});
export default MyMapComponent;